import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { errorMessage } from "@/lib/api";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying your Google sign-in…");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    // Emergent returns the session id in the URL fragment: #session_id=xxx
    const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
    const params = new URLSearchParams(hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("Missing session id — redirecting to sign in.");
      toast.error("Google sign-in failed: missing session id");
      setTimeout(() => navigate("/login", { replace: true }), 1200);
      return;
    }

    (async () => {
      try {
        await loginWithGoogleSession(sessionId);
        // Clean the URL
        window.history.replaceState({}, document.title, "/auth/callback");
        toast.success("Signed in with Google.");
        navigate("/app", { replace: true });
      } catch (err) {
        toast.error(errorMessage(err));
        setStatus("Sign-in failed. Redirecting…");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#050505] text-white">
      <div className="aurora opacity-50" />
      <div className="grain" />
      <div className="relative z-10 flex flex-col items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl brand-bg">
          <Sparkles className="h-6 w-6 text-white" />
        </div>
        <Loader2 className="h-5 w-5 animate-spin text-white/60" />
        <p className="text-sm text-white/60" data-testid="auth-callback-status">{status}</p>
      </div>
    </div>
  );
}
